import { useState } from "react";
import branding from "./branding";
import { API_BASE_URL } from "./apiConfig";

function Register({ onBackToLogin, language }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [paymentReference, setPaymentReference] = useState("");
  const requestedPaperCodes = [
    "physical_sciences_p1",
    "physical_sciences_p2",
  ];

  const handleRegister = async () => {
    if (!fullName || !email || !paymentReference || !password || !confirmPassword) {
      alert(
        language === "af"
          ? "Vul asseblief al die velde in."
          : "Please complete all fields."
      );
      return;
    }

    if (password !== confirmPassword) {
      alert(
        language === "af"
          ? "Die wagwoorde stem nie ooreen nie."
          : "The passwords do not match."
      );
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fullName,
            email,
            password,
            paymentReference,
            preferredLanguage: language,
            requestedPaperCodes,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Registration failed.");
        return;
      }

      alert(
        language === "af"
          ? "Registrasie ontvang. Jou rekening wag nou vir betalingsgoedkeuring."
          : "Registration received. Your account is awaiting payment approval."
      );

      setFullName("");
      setEmail("");
      setPaymentReference("");
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Registration request failed:", error);

      alert(
        language === "af"
          ? "Registrasie kon nie voltooi word nie. Probeer asseblief weer."
          : "Registration could not be completed. Please try again."
      );
    }

  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f3f6fb",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "40px",
          borderRadius: "15px",
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        }}
      >

        <div
          style={{
            textAlign: "center",
            marginBottom: "15px",
          }}
        >
          <img
            src="/ScienceTutor.png"
            alt="Science Tutor logo"
            style={{
              width: "190px",
              maxWidth: "100%",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>

        <h1
          style={{
            textAlign: "center",
            color: branding.primaryColor,
            marginTop: "0",
          }}
        >
          {branding.appName}
        </h1>

        <p style={{ textAlign: "center", color: "#666" }}>
          {language === "af"
            ? "Skep jou leerderrekening"
            : "Create your learner account"}
        </p>

        <input
          type="text"
          placeholder={language === "af" ? "Volle naam" : "Full name"}
          value={fullName}
          onChange={(event) => setFullName(event.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "20px",
            boxSizing: "border-box",
          }}
        />

        <div
          style={{
            marginTop: "15px",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            padding: "12px",
            color: "#374151",
            background: "#f8fafc",
            lineHeight: "1.5",
          }}
        >
          <strong>
            {language === "af"
              ? "EduVerse-toegang"
              : "EduVerse access"}
          </strong>
          <br />
          {language === "af"
            ? "Sodra jou rekening goedgekeur is, kan jy al die vraestelle gebruik wat reeds beskikbaar is. Nuwe vraestelle word outomaties bygevoeg wanneer hulle gereed is."
            : "Once your account is approved, you can use every paper that is ready. New papers are added automatically when they become available."}
        </div>

        <input
          type="email"
          placeholder={language === "af" ? "E-posadres" : "Email address"}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "15px",
            boxSizing: "border-box",
          }}
        />

        <input
          type="text"
          placeholder={
            language === "af"
              ? "Betalingsverwysing"
              : "Payment reference"
          }
          value={paymentReference}
          onChange={(event) =>
            setPaymentReference(event.target.value)
          }
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "15px",
            boxSizing: "border-box",
          }}
        />

        <input
          type="password"
          placeholder={language === "af" ? "Wagwoord" : "Password"}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "15px",
            boxSizing: "border-box",
          }}
        />

        <input
          type="password"
          placeholder={
            language === "af"
              ? "Bevestig wagwoord"
              : "Confirm password"
          }
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "15px",
            boxSizing: "border-box",
          }}
        />

        <button
          type="button"
          onClick={handleRegister}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "20px",
            background: branding.primaryColor,
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {language === "af" ? "Registreer" : "Register"}
        </button>

        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
            color: "#666",
          }}
        >
          {language === "af"
            ? "Het jy reeds 'n rekening?"
            : "Already have an account?"}
        </p>

        <button
          type="button"
          onClick={onBackToLogin}
          style={{
            width: "100%",
            background: "transparent",
            border: "none",
            color: branding.primaryColor,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {language === "af"
            ? "Terug na aanmelding"
            : "Back to login"}
        </button>
      </div>
    </div>
  );
}

export default Register;
